import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
    projectId: 'r5e7w4p1',
    dataset: 'production',
    apiVersion: '2021-11-16',
    useCdn: true,
    token: 'skxH787MvNd2bWQ9a6dI6VfUi9eme1YvHF4FtqVqNoJnbeokoOraQGwfyGEQuFDnaPyEwSFMzDJoORaoKY15uARRPhSleQYDKF6EJbvDxBI7K46jLKbKJi6YYyhDgxTpifRQ2s8eMuYaZ2vr4ocZfc2NZFkqd553wcgLqPbrVPbTDx3z4b6D',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);